/* ============================================
   TEST: CART-001 — Rebuy cart cross-sell widget rebuild
   Figma: 8BE90uBXiS4tTXYG3nP70n, node 2377-30377.

   Reads product data (titles, links, images, prices, variant
   selects, button labels) from the original Rebuy widget
   (.rebuy-widget.widget-type-cart) and renders a card slider
   (.et-cw01) right after it. Every interaction is proxied back
   to the hidden source widget, so Rebuy keeps handling variant
   state, add-to-cart, pricing and analytics.

   Active only when body has .test-cart-01 (Intelligems adds it
   on the test variant). If this script never runs, the stock
   widget stays visible — control-safe by construction.
   ============================================ */
(function () {
  'use strict';

  var BODY_CLASS = 'test-cart-01';
  var SOURCE_SELECTOR = '.rebuy-widget.widget-type-cart';
  var HIDE_CLASS = 'et-cw01-source-hidden';

  /* Test-variant header copy (Figma). Set in JS instead of the Rebuy
     admin so the control widget keeps its own texts. Empty string ->
     falls back to the source widget's super-title / description. */
  var COPY = {
    title: 'Take Your Training Further',
    pill: 'Save up to 55%'
  };

  /* Green benefit chip (Figma "✓ Fixes Your Grip"). The text comes
     from the product metafield custom.bundle_product_subtitle, fetched
     once per product via the Section Rendering API endpoint
     sections/et-cw01-usp.liquid. Entries here override the metafield
     (key = product handle); products with no value get no chip. */
  var BENEFITS = {};
  var USP_SECTION_ID = 'et-cw01-usp';
  var uspCache = {};

  var ICON_CHEVRON =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M4.14645 6.14645C4.34171 5.95118 4.65829 5.95118 4.85355 6.14645L8 9.29289L11.1464 6.14645C11.3417 5.95118 11.6583 5.95118 11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L4.14645 6.85355C3.95118 6.65829 3.95118 6.34171 4.14645 6.14645Z" fill="currentColor"/></svg>';

  var ICON_CHECK =
    '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M2.88068 5.34461C2.9588 5.25734 3.06175 5.15949 3.146 5.07523L3.60546 4.6157L5.02617 3.19501L6.29563 1.92562L6.70547 1.51582C6.85836 1.36291 6.98418 1.20355 7.20117 1.14497C7.36555 1.10127 7.54059 1.12526 7.68715 1.21159C7.83559 1.29855 7.94965 1.45273 7.98277 1.62209C7.98758 1.64675 7.99242 1.67307 7.99891 1.69722L8 1.70115V1.81502L7.99891 1.81877C7.9902 1.84997 7.98434 1.88502 7.97609 1.91735C7.95203 2.01208 7.90988 2.09304 7.84547 2.16679C7.77652 2.24577 7.69844 2.32025 7.62391 2.39466L7.27082 2.74757L6.12371 3.89478L4.11406 5.90465L3.61346 6.40523L3.44208 6.57676C3.36428 6.65488 3.28557 6.74008 3.18882 6.79469C3.04159 6.87941 2.86612 6.90027 2.70313 6.85242C2.49972 6.7941 2.38543 6.64652 2.24047 6.50414C2.2023 6.46668 2.16482 6.42836 2.12699 6.39055L1.50771 5.77148L0.629 4.89277L0.360566 4.62437C0.21436 4.47836 0.0589207 4.35086 0.0186293 4.14105C0.0154478 4.12449 0.00626313 4.0825 0 4.06895V3.92711C0.00842 3.9118 0.0186152 3.85392 0.0241405 3.83307C0.133088 3.42182 0.620879 3.23587 0.976742 3.46826C1.06932 3.52871 1.14294 3.61053 1.22071 3.68837L1.46995 3.93797L2.40445 4.87242L2.70221 5.17035C2.7562 5.22437 2.82425 5.29602 2.88068 5.34461Z" fill="currentColor"/></svg>';

  var scheduled = false;
  var openMenuEl = null;
  var activeDrag = null;

  /* Clones we removed ourselves. A removal of our node that is NOT
     in this set means Rebuy's Vue re-render kicked the clone out
     (happens when the cart drawer opens) -> we must rebuild. */
  var selfRemoved = new WeakSet();

  function removeClone(node) {
    selfRemoved.add(node);
    node.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (document.body.classList.contains(BODY_CLASS)) {
      start();
      return;
    }
    /* Intelligems adds the body class asynchronously on the test
       variant — wait for it instead of bailing out. */
    var classWatcher = new MutationObserver(function () {
      if (document.body.classList.contains(BODY_CLASS)) {
        classWatcher.disconnect();
        start();
      }
    });
    classWatcher.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    buildAll();

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (isRelevant(records[i])) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('pointerdown', function (e) {
      if (!openMenuEl) return;
      if (openMenuEl.contains(e.target)) return;
      if (openMenuEl._trigger && openMenuEl._trigger.contains(e.target)) return;
      closeMenu();
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.et-cw01').forEach(function (root) {
        if (root._updateProgress) root._updateProgress();
      });
    });

    window.addEventListener('pointermove', function (e) {
      if (!activeDrag) return;
      var dx = e.clientX - activeDrag.startX;
      if (Math.abs(dx) > 4) {
        activeDrag.moved = true;
        activeDrag.track.classList.add('is-dragging');
      }
      if (activeDrag.moved) activeDrag.track.scrollLeft = activeDrag.startScroll - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!activeDrag) return;
      activeDrag.track.classList.remove('is-dragging');
      var track = activeDrag.track;
      var moved = activeDrag.moved;
      activeDrag = null;
      if (moved) {
        /* swallow the click that follows a drag */
        track.addEventListener('click', function suppress(e) {
          e.preventDefault();
          e.stopPropagation();
          track.removeEventListener('click', suppress, true);
        }, true);
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      buildAll();
    });
  }

  function isOurs(node) {
    return node.nodeType === 1 && node.classList && node.classList.contains('et-cw01');
  }

  function isRelevant(rec) {
    var target = rec.target.nodeType === 1 ? rec.target : rec.target.parentElement;
    if (target && target.closest && target.closest('.et-cw01')) return false;

    var added = [].slice.call(rec.addedNodes);
    var removed = [].slice.call(rec.removedNodes);

    /* Our clone was removed by someone else (Vue re-render on cart
       open) -> rebuild so the widget reappears. */
    for (var i = 0; i < removed.length; i++) {
      if (isOurs(removed[i]) && !selfRemoved.has(removed[i])) return true;
    }

    /* Records produced purely by our own inserts/removals are noise. */
    var external = added.concat(removed).filter(function (n) {
      return !isOurs(n);
    });
    if ((added.length || removed.length) && !external.length) return false;

    if (!target || !target.closest) return false;
    if (target.closest(SOURCE_SELECTOR)) return true;

    for (var j = 0; j < external.length; j++) {
      var n = external[j];
      if (n.nodeType !== 1) continue;
      if (n.matches && n.matches(SOURCE_SELECTOR)) return true;
      if (n.querySelector && n.querySelector(SOURCE_SELECTOR)) return true;
    }
    return false;
  }

  function buildAll() {
    closeMenu();
    document.querySelectorAll('.et-cw01').forEach(function (root) {
      var prev = root.previousElementSibling;
      if (!prev || !prev.matches(SOURCE_SELECTOR)) removeClone(root);
    });
    document.querySelectorAll(SOURCE_SELECTOR).forEach(build);
  }

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function el(tag, className, textContent) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (textContent) node.textContent = textContent;
    return node;
  }

  /* Rebuy money nodes carry hidden a11y prefixes ("Sale price",
     "Original price") — strip hidden spans and keep just the amount,
     as in the design. */
  function moneyText(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    clone.querySelectorAll('[aria-hidden="true"], [hidden], .sr-only, .visually-hidden, .visuallyhidden, .screen-reader-only, .screen-reader-text').forEach(function (n) {
      n.remove();
    });
    var raw = clone.textContent.replace(/\s+/g, ' ').trim();
    var m = raw.match(/([€$£¥₴]\s?[\d.,]+|[\d.,]*\d\s?[€$£¥₴]|\d[\d.,]*)/);
    return m ? m[0].trim() : raw;
  }

  function parseMoney(str) {
    if (!str) return null;
    var m = str.replace(/[^\d.,]/g, '');
    if (!m) return null;
    var sep = Math.max(m.lastIndexOf(','), m.lastIndexOf('.'));
    if (sep > -1 && m.length - sep - 1 <= 2) {
      return parseFloat(m.slice(0, sep).replace(/[.,]/g, '') + '.' + m.slice(sep + 1));
    }
    return parseFloat(m.replace(/[.,]/g, ''));
  }

  function discountLabel(price, compare) {
    var p = parseMoney(price);
    var c = parseMoney(compare);
    if (!p || !c || c <= p) return '';
    return '-' + Math.round((1 - p / c) * 100) + '%';
  }

  function scrape(widget) {
    var items = [];
    widget.querySelectorAll('.rebuy-product-block').forEach(function (block, index) {
      var img = block.querySelector('.rebuy-product-media img') || block.querySelector('img');
      var titleEl = block.querySelector('.rebuy-product-title');
      var linkEl = (titleEl && titleEl.closest('a')) || block.querySelector('a[href*="/products/"]');
      var href = linkEl ? linkEl.getAttribute('href') || '' : '';

      var priceWrap = block.querySelector('.rebuy-product-price') || block;
      var sale = priceWrap.querySelector('.rebuy-money.sale');
      var compare = priceWrap.querySelector('.rebuy-money.compare-at');
      var monies = priceWrap.querySelectorAll('.rebuy-money');
      if (!sale && monies.length) sale = monies[0];
      if (!compare && monies.length > 1 && monies[monies.length - 1] !== sale) {
        compare = monies[monies.length - 1];
      }

      var button = block.querySelector('.rebuy-product-actions button') ||
        block.querySelector('button.rebuy-button') ||
        block.querySelector('button');

      var title = text(titleEl);
      if (!title && !img) return;

      items.push({
        index: index,
        title: title,
        url: href,
        handle: (href.match(/\/products\/([^/?#]+)/) || [])[1] || '',
        image: img ? img.currentSrc || img.src || '' : '',
        imageSrcset: img ? img.getAttribute('srcset') || '' : '',
        imageAlt: img ? img.getAttribute('alt') || title : title,
        price: moneyText(sale),
        compare: compare && compare !== sale ? moneyText(compare) : '',
        buttonText: text(button),
        selects: [].map.call(block.querySelectorAll('select'), function (sel, selIndex) {
          var selected = sel.selectedOptions && sel.selectedOptions[0];
          return {
            index: selIndex,
            value: sel.value,
            label: selected ? text(selected) : sel.value,
            options: [].map.call(sel.options, function (opt) {
              return { value: opt.value, label: text(opt), disabled: opt.disabled };
            })
          };
        })
      });
    });
    return items;
  }

  function uspFor(item) {
    if (item.handle && Object.prototype.hasOwnProperty.call(BENEFITS, item.handle)) {
      return BENEFITS[item.handle];
    }
    if (!item.handle) return '';
    var cached = uspCache[item.handle];
    if (typeof cached === 'string') return cached;
    if (!cached) {
      var url;
      try {
        url = new URL(item.url || '/products/' + item.handle, window.location.origin);
      } catch (e) {
        uspCache[item.handle] = '';
        return '';
      }
      url.search = 'section_id=' + USP_SECTION_ID;
      uspCache[item.handle] = fetch(url.toString())
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          var value = '';
          if (html) {
            var raw = new DOMParser().parseFromString(html, 'text/html').body.textContent.trim();
            try {
              value = JSON.parse(raw) || '';
            } catch (e) { /* endpoint not deployed / unexpected markup */ }
          }
          uspCache[item.handle] = typeof value === 'string' ? value : '';
          if (uspCache[item.handle]) schedule();
        })
        .catch(function () {
          uspCache[item.handle] = '';
        });
    }
    return '';
  }

  function getSourceBlock(root, index) {
    var widget = root.previousElementSibling;
    if (!widget || !widget.matches(SOURCE_SELECTOR)) return null;
    return widget.querySelectorAll('.rebuy-product-block')[index] || null;
  }

  function build(widget) {
    var items = scrape(widget);
    var existing = widget.nextElementSibling && widget.nextElementSibling.classList.contains('et-cw01')
      ? widget.nextElementSibling
      : null;

    if (!items.length) {
      if (existing) removeClone(existing);
      widget.classList.remove(HIDE_CLASS);
      return;
    }

    var prevScroll = 0;
    if (existing) {
      var prevTrack = existing.querySelector('.et-cw01__track');
      if (prevTrack) prevScroll = prevTrack.scrollLeft;
    }

    var root = el('section', 'et-cw01');

    var superTitle = COPY.title || text(widget.querySelector('.super-title'));
    var pillText = COPY.pill || text(widget.querySelector('.primary-title')) || text(widget.querySelector('.description'));
    if (superTitle || pillText) {
      var head = el('div', 'et-cw01__head');
      if (superTitle) {
        head.appendChild(el('h3', 'et-cw01__title', superTitle));
        root.setAttribute('aria-label', superTitle);
      }
      if (pillText) head.appendChild(el('span', 'et-cw01__pill', pillText));
      root.appendChild(head);
    }

    var track = el('div', 'et-cw01__track');
    items.forEach(function (item) {
      track.appendChild(renderCard(item, root));
    });
    root.appendChild(track);

    var progress = el('div', 'et-cw01__progress');
    var fill = el('span', 'et-cw01__progress-fill');
    progress.appendChild(fill);
    root.appendChild(progress);

    if (existing) removeClone(existing);
    widget.insertAdjacentElement('afterend', root);
    widget.classList.add(HIDE_CLASS);

    track.scrollLeft = prevScroll;
    bindSlider(root, track, progress, fill);
  }

  function renderCard(item, root) {
    var card = el('article', 'et-cw01__card');

    var media = el(item.url ? 'a' : 'div', 'et-cw01__media');
    if (item.url) media.setAttribute('href', item.url);
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      if (item.imageSrcset) {
        img.setAttribute('srcset', item.imageSrcset);
        img.setAttribute('sizes', '180px');
      }
      img.alt = item.imageAlt;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    var badge = discountLabel(item.price, item.compare);
    if (badge) media.appendChild(el('span', 'et-cw01__badge', badge));
    card.appendChild(media);

    var body = el('div', 'et-cw01__body');

    if (item.title) {
      var name = el(item.url ? 'a' : 'p', 'et-cw01__name', item.title);
      if (item.url) name.setAttribute('href', item.url);
      name.title = item.title;
      body.appendChild(name);
    }

    var benefit = uspFor(item);
    if (benefit) {
      var chip = el('span', 'et-cw01__chip');
      chip.innerHTML = ICON_CHECK;
      chip.appendChild(document.createTextNode(benefit));
      body.appendChild(chip);
    }

    if (item.price) {
      var prices = el('div', 'et-cw01__prices');
      prices.appendChild(el('span', 'et-cw01__price', item.price));
      if (item.compare) prices.appendChild(el('s', 'et-cw01__compare', item.compare));
      body.appendChild(prices);
    }

    if (item.selects.length) {
      var selects = el('div', 'et-cw01__selects');
      item.selects.forEach(function (sel) {
        selects.appendChild(renderSelect(item, sel, root));
      });
      body.appendChild(selects);
    }

    var cta = el('button', 'et-cw01__cta', item.buttonText || 'Add');
    cta.type = 'button';
    cta.addEventListener('click', function () {
      var block = getSourceBlock(root, item.index);
      if (!block) return;
      var btn = block.querySelector('.rebuy-product-actions button:not([disabled])') ||
        block.querySelector('button:not([disabled])');
      if (btn) btn.click();
    });
    body.appendChild(cta);

    card.appendChild(body);
    return card;
  }

  function renderSelect(item, sel, root) {
    var trigger = el('button', 'et-cw01__select');
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.appendChild(el('span', 'et-cw01__select-label', sel.label || 'Select'));
    trigger.insertAdjacentHTML('beforeend', ICON_CHEVRON);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu(root, trigger, item, sel);
    });
    return trigger;
  }

  function closeMenu() {
    if (!openMenuEl) return;
    if (openMenuEl._trigger) openMenuEl._trigger.setAttribute('aria-expanded', 'false');
    openMenuEl.remove();
    openMenuEl = null;
  }

  function toggleMenu(root, trigger, item, sel) {
    if (openMenuEl && openMenuEl._trigger === trigger) {
      closeMenu();
      return;
    }
    closeMenu();

    var menu = el('div', 'et-cw01__menu');
    menu._trigger = trigger;

    var head = el('button', 'et-cw01__menu-head');
    head.type = 'button';
    head.appendChild(el('span', 'et-cw01__select-label', sel.label || 'Select'));
    head.insertAdjacentHTML('beforeend', ICON_CHEVRON);
    head.addEventListener('click', closeMenu);
    menu.appendChild(head);
    menu.appendChild(el('span', 'et-cw01__menu-divider'));

    sel.options.forEach(function (opt) {
      if (opt.disabled || opt.value === '') return;
      var row = el('button', 'et-cw01__menu-option', opt.label);
      row.type = 'button';
      if (opt.value === sel.value) row.classList.add('is-selected');
      row.addEventListener('click', function () {
        closeMenu();
        trigger.querySelector('.et-cw01__select-label').textContent = opt.label;
        var block = getSourceBlock(root, item.index);
        if (!block) return;
        var source = block.querySelectorAll('select')[sel.index];
        if (!source) return;
        source.value = opt.value;
        /* Rebuy's Vue v-model listens for change; the resulting
           re-render of the source widget rebuilds this clone with
           fresh prices. */
        source.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.appendChild(row);
    });

    var rootRect = root.getBoundingClientRect();
    var trigRect = trigger.getBoundingClientRect();
    var left = trigRect.left - rootRect.left;
    left = Math.max(8, Math.min(left, root.clientWidth - trigRect.width - 8));
    menu.style.width = trigRect.width + 'px';
    menu.style.left = left + 'px';
    menu.style.top = trigRect.top - rootRect.top + 'px';

    root.appendChild(menu);
    trigger.setAttribute('aria-expanded', 'true');
    openMenuEl = menu;
  }

  function bindSlider(root, track, progress, fill) {
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) {
        progress.style.display = 'none';
        return;
      }
      progress.style.display = '';
      var barWidth = progress.clientWidth;
      var fillWidth = Math.max(Math.round(barWidth * (track.clientWidth / track.scrollWidth)), 16);
      fill.style.width = fillWidth + 'px';
      fill.style.transform = 'translateX(' + (track.scrollLeft / max) * (barWidth - fillWidth) + 'px)';
    }

    root._updateProgress = update;

    track.addEventListener('scroll', function () {
      closeMenu();
      update();
    }, { passive: true });

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      activeDrag = { track: track, startX: e.clientX, startScroll: track.scrollLeft, moved: false };
    });

    update();
  }
})();
